export const parseCpfCnpj = (value) => {
  value = String(value);
  const parsedValue = value
    .replace('.', '')
    .replace('.', '')
    .replace('/', '')
    .replace('-', '');
  return parsedValue;
};

export const parsePhone = (value) => {
  value = String(value);
  const parsedValue = value
    .replace('-', '')
    .replace('(', '')
    .replace(')', '')
    .replace(' ', '');
  return parsedValue;
};
